import React, { useState } from 'react';
import { Modal, Button, Typography, Box, Card, CardContent, CardActions, TextField, CircularProgress } from '@mui/material';
import { Payment } from '@mui/icons-material';
import ServerCall from '../../serverCall';
import toast from 'react-hot-toast';

const AddCompanyModal = ({ open, onClose, companyList }) => {
  const serverCall = ServerCall();
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState(false);

  const handlePay = async () => {
    if (!companyName || companyList.filter((item) => item.companyName === companyName).length) {
      //when company name is empty or not unique
      setCompanyNameError(true);
      return;
    }

    const payload = {
      companyName,
      companyId: "New",      //it is needed for backend
      reason: "Add"
    };
    setLoading(true);
    try {
      const response = await serverCall.customAxios.post(
        '/company',
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      const sessionUrl = response.data.sessionUrl;

      // Redirect to the sessionUrl
      window.location.href = sessionUrl;
    } catch (error) {
      console.error(error);
      toast.error("Failed to Add Company...");
    } finally {
      setLoading(false);
    }
  };

  const handleCompanyNameChange = (e) => {
    setCompanyName(e.target.value);
    if (e.target.value) {
      setCompanyNameError(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Card style={{ maxWidth: 500, padding: '20px' }}>
          <CardContent>
            <Typography variant="h5" component="div">
              Add Company
            </Typography>
            <Box display="flex" alignItems="center" marginTop={2}>
              <Payment style={{ fontSize: 40, marginRight: 10 }} />
              <Typography variant="body1">
                Pay $10 to add a new company
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" marginTop={2}>
              This will enable you to add a new company and access its features.
            </Typography>
            <Box mt={2} mb={2} width={"100%"}>
              <TextField
                fullWidth
                label="Enter Company Name"
                placeholder="Company Name"
                value={companyName}
                onChange={handleCompanyNameChange}
                margin="normal"
                variant="outlined"
                error={companyNameError}
                helperText={companyNameError ? "Company Name is required and must be unique" : ""}
                required
                InputProps={{
                  style: { maxWidth: "100%" }
                }}

              />
            </Box>
          </CardContent>
          <CardActions>
            <Button
              size="large"
              color="primary"
              onClick={handlePay}
              disabled={loading}
              style={{ position: 'relative' }}
            >
              {loading ? <CircularProgress size={24} style={{ position: 'absolute' }} /> : "Pay"}
            </Button>
            <Button size="large" color="secondary" onClick={onClose}>
              Cancel
            </Button>
          </CardActions>
        </Card>
      </Box>
    </Modal>
  );
};

export default AddCompanyModal;
